import React, { useRef } from 'react'
import { MapContainer,Marker,TileLayer,Popup } from 'react-leaflet'
import l from 'leaflet'
import 'leaflet/dist/leaflet.css'
const AdomMap = () => {
    const marker=l.icon({
        iconUrl:'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon-2x.png',
        iconSize:[25,35],
        popupAnchor:[-17,0],
        iconAnchor:[30,2]
        
    })
    const mapref=useRef()
  return (
    <div>
      <MapContainer center={[6.6734453,-1.5635425]} zoom={12} ref={mapref}>
      <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        <Marker position={[6.6722146,-1.5610092]} icon={marker}>
        <Popup>
                <h3>ADOM BI</h3>
            </Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}

export default AdomMap
